// Единый источник истины по типам долгов: подпись + иконка.
// Раньше карта была продублирована (и рассинхронизирована) в Debts,
// DebtFormSheet и DebtEditSheet — теперь все берут отсюда.

import type { ComponentType } from 'react';
import type { DebtKind } from '../api/types';
import {
  AlertTriangleIcon,
  BadgePercentIcon,
  BankIcon,
  BriefcaseIcon,
  CartIcon,
  type IconProps,
  PercentIcon,
  UsersIcon,
} from '../components/icons';

export const DEBT_KINDS: Record<
  DebtKind,
  { label: string; Icon: ComponentType<IconProps> }
> = {
  bank: { label: 'Банк', Icon: BankIcon },
  uzum: { label: 'Uzum', Icon: PercentIcon },
  uzum_zero: { label: 'Беспроцентный', Icon: BadgePercentIcon },
  installment: { label: 'Рассрочка', Icon: CartIcon },
  overdue: { label: 'Просрочка', Icon: AlertTriangleIcon },
  company: { label: 'Компания', Icon: BriefcaseIcon },
  personal: { label: 'Личное', Icon: UsersIcon },
};
